<h2 mat-dialog-title class="dialog-header">
  <span class="dialog-title title-large">Distinta assegni</span>

  <button
    mat-icon-button
    type="button"
    aria-label="Chiudi"
    class="close-button"
    (click)="chiudi()"
  >
    <i class="fa-regular fa-xmark"></i>
  </button>
</h2>

<mat-dialog-content class="content">
  <div class="checks-info-container">
    <div class="checks-info-icon-container" aria-hidden="true">
      <i class="fa-solid fa-circle-info"></i>
    </div>

    <span class="checks-info-text body-medium">Un incasso può contenere un solo assegno.</span>
  </div>

  <div class="check-details">
    <span class="label-medium-emphasized">Dettaglio assegno</span>

    <mat-form-field appearance="outline" subscriptSizing="dynamic">
      <mat-label>ABI</mat-label>
      <input matInput inputmode="numeric" maxlength="5" [(ngModel)]="check.abi"
             (input)="onBankCoordinateInput($event, 'abi')" />
    </mat-form-field>

    <mat-form-field appearance="outline" subscriptSizing="dynamic">
      <mat-label>CAB</mat-label>
      <input matInput inputmode="numeric" maxlength="5" [(ngModel)]="check.cab"
             (input)="onBankCoordinateInput($event, 'cab')" />
    </mat-form-field>

    <mat-form-field appearance="outline" subscriptSizing="dynamic">
      <mat-label>Banca</mat-label>
      <input matInput readonly [(ngModel)]="check.banca" />
      @if (isResolvingBank) {
        <i matSuffix class="fa-regular fa-spinner-third fa-spin" aria-label="Ricerca banca in corso"></i>
      }
    </mat-form-field>

    <mat-form-field appearance="outline" subscriptSizing="dynamic">
      <mat-label>Numero assegno</mat-label>
      <input matInput inputmode="numeric" maxlength="10" [(ngModel)]="check.numero"
             (input)="soloCifre($event, 'numero')" />
    </mat-form-field>

    <mat-form-field appearance="outline" subscriptSizing="dynamic">
      <mat-label>Importo</mat-label>
      <input matInput type="number" min="0" step="0.01" [(ngModel)]="check.importo" />
    </mat-form-field>

    <mat-form-field appearance="outline" subscriptSizing="dynamic">
      <mat-label>Data</mat-label>
      <input
        matInput
        [matDatepicker]="checkDatePicker"
        [(ngModel)]="check.data"
        placeholder="GG/MM/AAAA"
      />
      <mat-datepicker-toggle matIconSuffix [for]="checkDatePicker" />
      <mat-datepicker #checkDatePicker />
    </mat-form-field>

    <mat-form-field appearance="outline" subscriptSizing="dynamic">
      <mat-label>Tipo</mat-label>
      <mat-select [(ngModel)]="check.tipo">
        <mat-option value="bancario">Bancario</mat-option>
        <mat-option value="circolare">Circolare</mat-option>
        <mat-option value="circolareVersamentoContanti">
          Circolare per versamento contanti
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  @if (errore) {
    <div class="check-error body-medium" role="alert">{{ errore }}</div>
  }
</mat-dialog-content>

<mat-dialog-actions class="check-actions">
  <button
    matButton="filled"
    type="button"
    [disabled]="isValidating || isResolvingBank || !check.banca"
    (click)="conferma()"
  >
    Conferma
  </button>
</mat-dialog-actions>
